import React from 'react'
import './countCard.css'
import C2wImageIcon from '../Icon/ImageIcon'

function C2wCountCard( { onClick, obj, index } ) {

  const renderedImageIcons = obj?.imgArr?.map(( imgSrc, index ) => {
    return  <C2wImageIcon  imgSrc={imgSrc} index={index} />
  })

  return (
    <div className='C2wCountCard_ctn' style={{borderBottom: index === 2 ? 'none' : null, cursor: index !== 0 ? 'pointer' : null }} onClick={onClick}>
        <span className='C2wCountCard_ctn_heading'>{obj?.heading}</span>
        <span className='C2wCountCard_ctn_Count'>{obj?.count}+</span>
        <div className='C2wCountCard_ctn_Img_holder'>
          {renderedImageIcons}
        </div>
    </div>  
  )
}

export default C2wCountCard
